import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { ILpAdapterSchemas } from '@cbridge-packages/lp-adapters';
import { IClientLp, IClientLpForm } from './clientLp.interface';

export namespace ClientLpAction {
  const actionCreator = actionCreatorFactory('ClientLp');

  export const load = actionCreator.async<{ lpId: IClientLp['lpId'] }, IClientLp, IApiErrorParams>('LOAD');
  export const loadAdapterSchema = actionCreator.async<
    { adapterName: IClientLp['adapter'] },
    ILpAdapterSchemas,
    IApiErrorParams | null
  >('LOAD_ADAPTER_SCHEMA');
  export const loadList = actionCreator.async<void, IClientLp[], IApiErrorParams>('LOAD_LIST');
  export const update = actionCreator.async<IClientLpForm, void, IApiErrorParams>('UPDATE');
  export const processing = actionCreator.async<void, void, { error: Error }>('PROCESSING');
  export const destroy = actionCreator('DESTROY');
}
